var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcDelete = function SvgIcDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11 20a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM8.53 7.47a.75.75 0 1 0-1.06 1.06L9.94 11l-2.47 2.47a.75.75 0 0 0 1.06 1.06L11 12.06l2.47 2.47a.75.75 0 1 0 1.06-1.06L12.06 11l2.47-2.47a.75.75 0 0 0-1.06-1.06L11 9.94 8.53 7.47Z",
    clipRule: "evenodd"
  })));
};
export default SvgIcDelete;